import React from 'react';

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Button } from '@components/button';

import * as Styled from './card.styled';

type OwnProps = {
	title: string;
	link: string;
	image: string;
};

const Card: React.FC<OwnProps> = ({ title, link, image }) => {
	const { t } = useTranslation('main');

	
	return (
		<Link to={link}>
			<Styled.Wrapper $bgImage={image}>
				<Styled.Title dangerouslySetInnerHTML={{ __html: title }} />

				<Button color='neutral' hasIcon>
					{t('go')}
				</Button>
			</Styled.Wrapper>
		</Link>
	);
};
export default Card;
